import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ProviderUserProfile } from './contexts/UserProfileContext';
import { ProviderGlobalFeatures } from './contexts/GlobalFeatures';
import { NotificationsProvider } from './contexts/NotificationsContext';
import ThemeWrapper from './contexts/ThemeWrapper';
import AppGate from './AppGate';
import { setFavicon } from './utils/usefulFunctions';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { HotelOwnerProvider } from './contexts/HotelOwnerContext';
import RedirectToOwnerPortal from './utils/RedirectToOwnerPortal';
import NotificationsBar from './components/NotificationsBar';
import './stylesheets/theme.module.scss';
import './stylesheets/App.scss';
import './stylesheets/common.scss';

setFavicon();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <ErrorBoundary>
            <ProviderGlobalFeatures>
                <NotificationsProvider>
                    <AuthProvider>
                        <ProviderUserProfile>
                            <HotelOwnerProvider>
                                <ThemeWrapper>
                                    <Switch>
                                        <Route
                                            path='/redirect=/:token/:webToken/:sid/:rol/:IdHotelOwner/:encodedUsername'
                                            component={RedirectToOwnerPortal}
                                        />
                                        <Route
                                            path='/'
                                            render={props => (
                                                <AppGate {...props} />
                                            )}
                                        />
                                    </Switch>
                                    <NotificationsBar />
                                </ThemeWrapper>
                            </HotelOwnerProvider>
                        </ProviderUserProfile>
                    </AuthProvider>
                </NotificationsProvider>
            </ProviderGlobalFeatures>
        </ErrorBoundary>
    </BrowserRouter>
);
